module.exports = __webpack_public_path__ + "static/media/icon_send.5e3eb828.svg";